import capitalizeFirstLetter from 'common/util/capitalizeFirstLetter';

export default function getPrettyName(uglyName: string): string {
  return uglyName
    .replace(/[_-]/g, ' ')
    .replace(/([a-z0-9])([A-Z])/, '$1 $2')
    .split(/\s+/g)
    .map(capitalizeFirstLetter)
    .join(' ');
}
